const SchedulingShifts = (function () {
  // DATA
  let shiftEmployees;
  let filterShiftEmployeesOpts;
  let regions;
  let workcodes;
  // DOM
  let shiftGroupPopup;
  // Month view group popup
  let isShiftGroupPopupOpen;
  let groupPopupEventLookup;
  let groupPopupDateISO;
  //
  let ScheduleCalendar;

  function checkRequiredFields(scope, btn) {
    var hasErrors = [].slice.call(scope.querySelectorAll('.error'));

    if (hasErrors.length === 0) {
      btn.classList.remove('disabled');
    } else {
      btn.classList.add('disabled');
    }
  }
  function rgba([r, g, b], a = 1) {
    const mix = channel => Math.round(channel + (255 - channel) * a);
    const newR = mix(r);
    const newG = mix(g);
    const newB = mix(b);

    return `rgb(${newR}, ${newG}, ${newB})`;
  }
  function sortEmployeeString(a, b) {
    const [aLast, aFirst] = a.text.split(',').map(s => s.trim());
    const [bLast, bFirst] = b.text.split(',').map(s => s.trim());

    const lastCmp = aLast.localeCompare(bLast, undefined, { sensitivity: 'base' });
    if (lastCmp !== 0) return lastCmp;

    return aFirst.localeCompare(bFirst, undefined, { sensitivity: 'base' });
  }
  function showSuccessFailPopup(success, message, removeOverlay = true) {
    if (success) {
      if (!message) message = 'SAVED';
      successfulSave.show(message);
      setTimeout(function () {
        successfulSave.hide(removeOverlay);
      }, 1500);
    } else {
      if (!message) message = 'ERROR SAVING';
      failSave.show(message);
      setTimeout(function () {
        failSave.hide(removeOverlay);
      }, 1500);
    }
  }

  // Shift Request & Call Off Request
  //-----------------------------------------------------------------------
  function populateCallOffReasonsDropdown(results, reasonDropdown) {
    results.sort((a, b) => (a.reasonName < b.reasonName ? -1 : 1));
    results = [{ reasonId: '%', reasonName: '' }, ...results];
    var dropdownData = results.map(r => {
      var id = r.reasonId;
      var value = r.reasonName;
      var text = r.reasonName;
      return {
        id,
        value,
        text,
      };
    });
    dropdown.populate(reasonDropdown, dropdownData);
    // reasonDropdown.addEventListener('change', () => {
    //   var selectedOption = event.target.options[event.target.selectedIndex];
    //   reasonId = selectedOption.id;
    // })
  }
  function populateCallOffEmployeesDropdown(results, employeeDropdown) {
    results = [{ employeeId: '%', employeeName: '' }, ...results];
    var employeeData = results.map(r => {
      var id = r.employeeId;
      var value = r.employeeName;
      var text = r.employeeName;
      return {
        id,
        value,
        text,
      };
    });

    dropdown.populate(employeeDropdown, employeeData);
    // employeeDropdown.addEventListener('change', () => {
    //   var sendRequestBtn = document.getElementById('sendReqBtn')
    //   var selectedOption = event.target.options[event.target.selectedIndex];
    //   employeeId = selectedOption.id;
    //   employeeId !== '%' ? sendRequestBtn.classList.remove('disabled'): sendRequestBtn.classList.add('disabled');
    // });
  }
  function renderRequestOffPopup({ shiftId, shiftDate, shiftLocation }, cb) {
    let reasonId, note, employeeId;

    const popup = POPUP.build({
      classNames: 'request-off-popup',
      attributes: [{ key: 'shiftId', value: shiftId }],
    });

    const reasonDropdown = dropdown.build({
      dropdownId: 'reasonDropdown',
      label: 'Reason',
      style: 'secondary',
      readOnly: 'false',
    });

    const notesInput = input.build({
      id: 'noteInput',
      label: 'Notes',
      type: 'textarea',
      style: 'secondary',
    });

    const employeeDropdown = dropdown.build({
      dropdownId: 'employeeDropdown',
      label: 'Employee To Notify',
      style: 'secondary',
    });

    const cancelBtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'outlined',
      icon: 'close',
      callback: function () {
        POPUP.hide(popup);
      },
    });

    const sendRequestBtn = button.build({
      id: 'sendReqBtn',
      text: 'Send Request',
      classNames: 'disabled',
      style: 'secondary',
      type: 'contained',
      icon: 'send',
      callback: function () {
        _UTIL.fetchData('saveSchedulingCallOffRequest', {
          shiftId: shiftId,
          personId: $.session.PeopleId,
          reasonId: reasonId,
          note: note,
          status: 'P',
          notifiedEmployeeId: employeeId,
        });

        POPUP.hide(popup);
        if (isShiftGroupPopupOpen) {
          overlay.show();
        }

        cb();
      },
    });

    reasonDropdown.classList.add('error');
    notesInput.classList.add('error');
    employeeDropdown.classList.add('error');

    reasonDropdown.addEventListener('change', e => {
      var selectedOption = e.target.options[e.target.selectedIndex];
      reasonId = selectedOption.id;

      if (reasonId === '%') {
        reasonDropdown.classList.add('error');
      } else {
        reasonDropdown.classList.remove('error');
      }

      checkRequiredFields(popup, sendRequestBtn);
    });

    notesInput.addEventListener('change', e => {
      note = e.target.value;

      if (e.target.value === '') {
        notesInput.classList.add('error');
      } else {
        notesInput.classList.remove('error');
      }

      checkRequiredFields(popup, sendRequestBtn);
    });

    employeeDropdown.addEventListener('change', e => {
      var selectedOption = e.target.options[e.target.selectedIndex];
      employeeId = selectedOption.id;

      if (employeeId === '%') {
        employeeDropdown.classList.add('error');
      } else {
        employeeDropdown.classList.remove('error');
      }

      checkRequiredFields(popup, sendRequestBtn);
    });

    let header = document.createElement('h2');
    header.classList.add('detailsHeading');
    header.innerHTML = 'Call Off Request';

    let btnWrap = document.createElement('div');
    btnWrap.classList.add('popupBtnWrap');
    btnWrap.appendChild(sendRequestBtn);
    btnWrap.appendChild(cancelBtn);

    popup.appendChild(header);
    popup.appendChild(reasonDropdown);
    popup.appendChild(notesInput);
    popup.appendChild(employeeDropdown);
    popup.appendChild(btnWrap);

    POPUP.show(popup);

    Promise.all([
      _UTIL.fetchData('getCallOffDropdownEmployees', {
        shiftDate: shiftDate,
        locationId: shiftLocation,
      }),
      _UTIL.fetchData('getCallOffDropdownReasons'),
    ]).then(([employeesResp, reasonsResp]) => {
      populateCallOffEmployeesDropdown(
        employeesResp.getCallOffDropdownEmployeesResult,
        employeeDropdown,
      );
      populateCallOffReasonsDropdown(reasonsResp.getCallOffDropdownReasonsResult, reasonDropdown);
    });
  }
  function displayOverlapPopup(existingShiftLocationName) {
    const overlapPopup = POPUP.build({
      classNames: 'sendRequestShiftPopup',
    });

    overlapWrap = document.createElement('div');
    overlapWrap.innerHTML = `
      <div class="detailsHeading">
        <h2>Requested Shift Overlap</h2>
        <p>This open shift overlaps with an existing shift you are scheduled to work at ${existingShiftLocationName}. You cannot request this open shift.</p>
      </div>
    `;

    const overlapCancelBtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'outlined',
      icon: 'close',
      callback: function () {
        POPUP.hide(overlapPopup);
      },
    });

    overlapPopup.appendChild(overlapWrap);
    overlapPopup.appendChild(overlapCancelBtn);

    POPUP.show(overlapPopup);
  }
  function renderSendShiftRequestPopup({ shiftDate, shiftLocation, ...data }, cb) {
    let employeeId;

    const popup = POPUP.build({
      classNames: 'sendRequestShiftPopup',
    });

    wrap = document.createElement('div');
    wrap.innerHTML = `
          <div class="detailsHeading">
            <h2>Request Open Shift</h2>
          </div>

          <div class="detailsBody">
            <div class="dropdown-wrap">
              <span class="requestError"></span>
            </div>
          </div>
      `;
    popup.appendChild(wrap);

    const employeeDropdown = dropdown.build({
      dropdownId: 'employeeDropdown',
      label: 'Employee To Notify',
      style: 'secondary',
    });
    employeeDropdown.classList.add('error');
    employeeDropdown.addEventListener('change', e => {
      const selectedOption = e.target.options[e.target.selectedIndex];
      employeeId = selectedOption.id;

      if (employeeId === '%') {
        employeeDropdown.classList.add('error');
      } else {
        employeeDropdown.classList.remove('error');
      }

      checkRequiredFields(popup, sendRequestBtn);
    });

    const cancelBtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'outlined',
      icon: 'close',
      callback: function () {
        POPUP.hide(popup);
      },
    });
    const sendRequestBtn = button.build({
      id: 'sendReqBtn',
      classNames: 'disabled',
      text: 'Send Request',
      style: 'secondary',
      type: 'contained',
      icon: 'send',
      callback: async function () {
        data.notifiedEmployeeId = employeeId;

        await _UTIL.fetchData('saveOpenShiftRequestScheduling', { ...data });

        POPUP.hide(popup);
        if (isShiftGroupPopupOpen) {
          overlay.show();
        }

        cb();
      },
    });

    _UTIL
      .fetchData('getCallOffDropdownEmployees', { shiftDate: shiftDate, locationId: shiftLocation })
      .then(resp => {
        populateCallOffEmployeesDropdown(resp.getCallOffDropdownEmployeesResult, employeeDropdown);
      });

    popup.appendChild(employeeDropdown);

    const btnWrap = document.createElement('div');
    btnWrap.classList.add('popupBtnWrap');
    btnWrap.appendChild(sendRequestBtn);
    btnWrap.appendChild(cancelBtn);
    popup.appendChild(btnWrap);

    POPUP.show(popup);
  }

  // Shifts
  //-----------------------------------------------------------------------
  // Shift Group Popup
  //------------------------------------
  function formatDateForHeader(dirtyDate) {
    const getOrdinalSuffix = day => {
      if (day > 3 && day < 21) return 'th';
      switch (day % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    const dateString = dirtyDate.toLocaleDateString('en-US', {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
    });
    const weekdayAndMonth = dateString.slice(0, -2);
    const dayNumber = dateString.slice(-2);
    const suffix = getOrdinalSuffix(dayNumber);
    return `${weekdayAndMonth} ${parseInt(dayNumber)}${suffix}`;
  }
  function formatShiftName(firstName, lastName) {
    if (!firstName && !lastName) return '';
    if (firstName && !lastName) return firstName;
    return `${lastName}, ${firstName}`;
  }
  function updateShiftGroupPopup() {
    const appointments = SchedulingCalendar.getAppointments();
    const schedules = SchedulingCalendar.getSchedules();

    const shiftIds = ScheduleCalendar.getShiftIdsByDay(groupPopupDateISO);
    const targetEvents = [...appointments, ...schedules].filter(ev =>
      shiftIds.includes(ev.shiftId),
    );

    const eventsWrapEle = shiftGroupPopup.querySelector('#eventsWrapEle');
    eventsWrapEle.innerHTML = '';

    groupPopupEventLookup = {};

    if (!targetEvents.length) {
      POPUP.hide(shiftGroupPopup);
      isShiftGroupPopupOpen = false;
      shiftGroupPopup = null;
    }

    targetEvents.forEach(event => {
      const startTime = dates.convertFromMilitary(event.startTime);
      const endTime = dates.convertFromMilitary(event.endTime);

      const shiftEle = document.createElement('div');
      shiftEle.className = 'eventCell';
      shiftEle.setAttribute('data-event-id', event.shiftId);
      shiftEle.setAttribute('data-type-id', event.typeId);
      shiftEle.style.backgroundColor = rgba(event.colorCode, 0.3);

      const formatedShiftName = formatShiftName(event.firstName, event.lastName);

      if (event.typeId === 6) {
        const timeString = startTime
          ? `<span class="timeString">${startTime}</span> - <span class="timeString">${endTime}</span>`
          : '';
        const eventDescription = SchedulingCalendar.abbreviateAppointment(event.typeDescription);
        const eventNameOrPlaceholder =
          event.takenToApptBy && event.takenToApptBy.trim() !== ','
            ? ''
            : '<p>Open Appointment</p>';

        shiftEle.classList.add('appointment');
        shiftEle.innerHTML = `
          <div>
            <p class="eventTime">
              <span class="peopleIcon">${icons.people}</span> ${timeString}
            </p>
            <div class="details">
              ${eventNameOrPlaceholder}
              ${formatedShiftName ? `<p>${formatedShiftName}</p>` : ``}
              <p>${eventDescription} - ${event.consumerName}</p>
              ${
                event.takenToApptBy && event.takenToApptBy.trim() !== ','
                  ? `<p>${event.takenToApptBy}</p>`
                  : ``
              }
            </div>
          </div>
          ${$.session.schedulingSecurity ? `<p class="pubUnpubIcon">${icons.show}</p>` : ''}
        `;
      } else {
        const isPublished = event.publishDate;
        const icon = isPublished ? icons.show : icons.eyeClose;
        const pubUnpubIcon = `${
          $.session.schedulingSecurity ? `<p class="pubUnpubIcon">${icon}</p>` : ``
        }`;

        shiftEle.innerHTML = `
          <div>
            <p class="eventTime">
              <span>${startTime}</span> - <span>${endTime}</span>
            </p>
            <div class="details">
              ${formatedShiftName ? `<p>${formatedShiftName}</p>` : `<p>Open Shift</p>`}
              <p>${event.locationName}</p>
            </div>
          </div>
          ${pubUnpubIcon}
        `;
      }

      eventsWrapEle.appendChild(shiftEle);

      groupPopupEventLookup[event.shiftId] = event;
    });
  }
  function showShiftGroupPopup(events, dateISO) {
    isShiftGroupPopupOpen = true;
    groupPopupDateISO = dateISO;
    groupPopupEventLookup = {};

    shiftGroupPopup = POPUP.build({
      id: 'shiftGroupDetailPopup',
      closeCallback: () => {
        isShiftGroupPopupOpen = false;
        shiftGroupPopup = null;
      },
    });

    // header
    const viewDate = new Date(`${dateISO} 00:00:00`);
    const headerEle = document.createElement('p');
    headerEle.className = 'groupDetailsHeader';
    headerEle.innerHTML = formatDateForHeader(viewDate);
    shiftGroupPopup.appendChild(headerEle);

    // events
    const eventsWrapEle = document.createElement('div');
    eventsWrapEle.id = 'eventsWrapEle';
    eventsWrapEle.className = 'groupEventsWrap';
    shiftGroupPopup.appendChild(eventsWrapEle);

    events.forEach(event => {
      const startTime = dates.convertFromMilitary(event.startTime);
      const endTime = dates.convertFromMilitary(event.endTime);

      const shiftEle = document.createElement('div');
      shiftEle.className = 'eventCell';
      shiftEle.setAttribute('data-event-id', event.shiftId);
      shiftEle.setAttribute('data-type-id', event.typeId);
      shiftEle.style.backgroundColor = rgba(event.colorCode, 0.3);

      const formatedShiftName = formatShiftName(event.firstName, event.lastName);

      if (event.typeId === 6) {
        const timeString = startTime
          ? `<span class="timeString">${startTime}</span> - <span class="timeString">${endTime}</span>`
          : '';
        const eventDescription = SchedulingCalendar.abbreviateAppointment(event.typeDescription);
        const eventNameOrPlaceholder =
          event.takenToApptBy && event.takenToApptBy.trim() !== ','
            ? ''
            : '<p>Open Appointment</p>';

        shiftEle.classList.add('appointment');
        shiftEle.innerHTML = `
          <div>
            <p class="eventTime">
              <span class="peopleIcon">${icons.people}</span> ${timeString}
            </p>
            <div class="details">
              ${eventNameOrPlaceholder}
              ${formatedShiftName ? `<p>${formatedShiftName}</p>` : ``}
              <p>${eventDescription} - ${event.consumerName}</p>
              ${
                event.takenToApptBy && event.takenToApptBy.trim() !== ','
                  ? `<p>${event.takenToApptBy}</p>`
                  : ``
              }
            </div>
          </div>
          ${$.session.schedulingSecurity ? `<p class="pubUnpubIcon">${icons.show}</p>` : ''}
        `;
      } else {
        const isPublished = event.publishDate;
        const icon = isPublished ? icons.show : icons.eyeClose;
        const pubUnpubIcon = `${
          $.session.schedulingSecurity ? `<p class="pubUnpubIcon">${icon}</p>` : ``
        }`;

        shiftEle.innerHTML = `
          <div>
            <p class="eventTime">
              <span>${startTime}</span> - <span>${endTime}</span>
            </p>
            <div class="details">
              ${formatedShiftName ? `<p>${formatedShiftName}</p>` : `<p>Open Shift</p>`}
              <p>${event.locationName}</p>
            </div>
          </div>
          ${pubUnpubIcon}
        `;
      }

      eventsWrapEle.appendChild(shiftEle);

      groupPopupEventLookup[event.shiftId] = event;
    });

    eventsWrapEle.addEventListener('click', e => {
      const eventId = e.target.dataset.eventId;
      const eventTypeId = e.target.dataset.typeId;

      showEventDetailsPopup({
        eventTypeId,
        data: groupPopupEventLookup[eventId],
        isCopy: false,
      });
    });

    POPUP.show(shiftGroupPopup);
  }
  // Single Shift Popup
  //------------------------------------
  // - filter employee -
  function populateRegionDropdown(regionDropdown, selectedRegion) {
    const dropdownData = regions
      .map(r => ({
        value: r.regionId,
        text: r.description,
      }))
      .sort((a, b) => a.text.localeCompare(b.text));

    dropdownData.unshift({
      value: '',
      text: '',
    });

    dropdown.populate(regionDropdown, dropdownData, selectedRegion);
  }
  function buildLocationFilter(includeTrainedOnly) {
    // <div class="employeeOption">
    // ${locationCheck.outerHTML}
    //   <div class="label">
    //     <p>Only include employees trained at the location</p>
    //   </div>
    // </div>

    const employeeOption = document.createElement('div');
    employeeOption.className = 'employeeOption';

    const locationCheck = document.createElement('input');
    locationCheck.type = 'checkbox';
    locationCheck.name = 'location';
    locationCheck.checked = includeTrainedOnly === 1 ? true : false;

    const label = document.createElement('div');
    label.className = 'label';
    label.innerHTML = `<p>Only include employees trained at the location</p>`;

    employeeOption.appendChild(locationCheck);
    employeeOption.appendChild(label);

    return { locationFilter: employeeOption };
  }
  function buildHoursFilter(filterHours, maxWeeklyHours) {
    // <div class="employeeOption">
    // ${hoursCheck.outerHTML}
    //   <div class="label nestedInput">
    //     <p>Exclude employees that would have more than</p>
    //     ${hoursInput.outerHTML}
    //     <p> hours for the work week</p>
    //   </div>
    // </div>

    const employeeOption = document.createElement('div');
    employeeOption.className = 'employeeOption';

    const hoursCheck = document.createElement('input');
    hoursCheck.checked = filterHours === 1 ? true : false;
    hoursCheck.type = 'checkbox';
    hoursCheck.name = 'hour';

    const hoursInput = document.createElement('input');
    hoursInput.type = 'number';
    hoursInput.name = 'hours';
    hoursInput.value = maxWeeklyHours && maxWeeklyHours !== -1 ? maxWeeklyHours : '';

    const label = document.createElement('div');
    label.className = 'label nestedInput';
    const labelText1 = document.createElement('p');
    labelText1.innerHTML = `<p>Exclude employees that would have more than</p>`;
    const labelText2 = document.createElement('p');
    labelText2.innerHTML = `<p> hours for the work week</p>`;

    label.appendChild(labelText1);
    label.appendChild(hoursInput);
    label.appendChild(labelText2);

    employeeOption.appendChild(hoursCheck);
    employeeOption.appendChild(label);

    return {
      hoursFilter: employeeOption,
      hoursCheck,
      hoursInput,
    };
  }
  function buildMinutesFilter(filterMinutes, minTimeBetweenShifts) {
    // <div class="employeeOption">
    // ${minutesCheck.outerHTML}
    //   <div class="label nestedInput">
    //     <p>Exclude employees that have a shift less than</p>
    //     ${minutesInput.outerHTML}
    //     <p>minutes before this one</p>
    //   </div>
    // </div>

    const employeeOption = document.createElement('div');
    employeeOption.className = 'employeeOption';

    const minutesCheck = document.createElement('input');
    minutesCheck.checked = filterMinutes === 1 ? true : false;
    minutesCheck.type = 'checkbox';
    minutesCheck.name = 'minute';

    const minutesInput = document.createElement('input');
    minutesInput.type = 'number';
    minutesInput.name = 'minutes';
    minutesInput.value =
      minTimeBetweenShifts && minTimeBetweenShifts !== -1 ? minTimeBetweenShifts : '';

    const label = document.createElement('div');
    label.className = 'label nestedInput';
    const labelText1 = document.createElement('p');
    labelText1.innerHTML = `<p>Exclude employees that have a shift less than</p>`;
    const labelText2 = document.createElement('p');
    labelText2.innerHTML = `<p> minutes before this one</p>`;

    label.appendChild(labelText1);
    label.appendChild(minutesInput);
    label.appendChild(labelText2);

    employeeOption.appendChild(minutesCheck);
    employeeOption.appendChild(label);

    return {
      minutesFilter: employeeOption,
      minutesCheck,
      minutesInput,
    };
  }
  function buildDayOffOverlapFilter(includeOverlaps) {
    // <div class="employeeOption">
    // ${overlapCheck.outerHTML}
    //   <div class="label">
    //     <p>Exclude employees who have a day off that overlaps with this shift</p>
    //   </div>
    // </div>

    const employeeOption = document.createElement('div');
    employeeOption.className = 'employeeOption';

    const overlapCheck = document.createElement('input');
    overlapCheck.type = 'checkbox';
    overlapCheck.name = 'overlap';
    overlapCheck.checked = includeOverlaps === 1 ? true : false;

    const label = document.createElement('div');
    label.className = 'label';
    label.innerHTML = `<p>Exclude employees who have a day off that overlaps with this shift</p>`;

    employeeOption.appendChild(overlapCheck);
    employeeOption.appendChild(label);

    return { overlapFilter: employeeOption };
  }
  function buildShfitOverlapFilter(excludeDiffLocationOverlap) {
    const employeeOption = document.createElement('div');
    employeeOption.className = 'employeeOption';

    const overlapCheck = document.createElement('input');
    overlapCheck.type = 'checkbox';
    overlapCheck.name = 'overlapShift';
    // T.198690: this checkbox controls the DIFFERENT-location overlap exclusion.
    overlapCheck.checked = excludeDiffLocationOverlap === 1 ? true : false;

    const label = document.createElement('div');
    label.className = 'label';
    label.innerHTML = `<p>Exclude employees who have an overlapping shift at a different location</p>`;

    employeeOption.appendChild(overlapCheck);
    employeeOption.appendChild(label);

    return { overlapShiftFilter: employeeOption };
  }
  function buildRegionFilter(filterRegion) {
    // <div class="employeeOption">
    // ${regionCheck.outerHTML}
    //   <div class="label">
    //     <p>Only show employees from this region:</p>
    //   </div>
    // </div>

    const employeeOption = document.createElement('div');
    employeeOption.className = 'employeeOption';

    const regionCheck = document.createElement('input');
    regionCheck.checked = filterRegion === 1 ? true : false;
    regionCheck.type = 'checkbox';
    regionCheck.name = 'region';

    const label = document.createElement('div');
    label.className = 'label';
    label.innerHTML = `<p>Only show employees from this region</p>`;

    employeeOption.appendChild(regionCheck);
    employeeOption.appendChild(label);

    return { regionFilter: employeeOption };
  }
  function showFilterEmployeePopup(onSaveCallbackFunc) {
    const opts = {
      ...filterShiftEmployeesOpts,
    };

    const employeePopup = POPUP.build({
      id: 'filterEmployeePopup',
      hideX: true,
    });

    const title = document.createElement('p');
    title.className = 'popupTitle';
    title.textContent = 'Select employee options';

    const optionsContainer = document.createElement('div');
    optionsContainer.className = 'employeeOptionsContainer';

    const { locationFilter } = buildLocationFilter(opts.includeTrainedOnly);
    const { hoursFilter, hoursInput } = buildHoursFilter(opts.filterHours, opts.maxWeeklyHours);
    const { minutesFilter, minutesInput } = buildMinutesFilter(
      opts.filterMinutes,
      opts.minTimeBetweenShifts,
    );
    const { overlapFilter } = buildDayOffOverlapFilter(opts.includeOverlaps);
    const { overlapShiftFilter } = buildShfitOverlapFilter(opts.excludeDiffLocationOverlap);
    const { regionFilter } = buildRegionFilter(opts.filterRegion);
    const regionDropdown = dropdown.build({
      dropdownId: 'regionDropdown',
      label: 'Region',
      style: 'secondary',
    });

    if (opts.filterRegion === 0) {
      input.disableInputField(regionDropdown);
    }
    if (opts.filterHours === 0) {
      input.disableInputField(hoursInput);
    }
    if (opts.filterMinutes === 0) {
      input.disableInputField(minutesInput);
    }

    optionsContainer.appendChild(locationFilter);
    optionsContainer.appendChild(hoursFilter);
    optionsContainer.appendChild(minutesFilter);
    optionsContainer.appendChild(overlapFilter);
    if ($.session.flag.employeeFilter) optionsContainer.appendChild(overlapShiftFilter);
    optionsContainer.appendChild(regionFilter);
    optionsContainer.appendChild(regionDropdown);

    const savebtn = button.build({
      text: 'Update Employee List',
      style: 'secondary',
      type: 'contained',
      callback: async () => {
        employeePopup.remove();
        bodyScrollLock.enableBodyScroll(employeePopup);
        filterShiftEmployeesOpts = { ...opts };
        onSaveCallbackFunc();
      },
    });
    const cancelbtn = button.build({
      text: 'cancel',
      style: 'secondary',
      type: 'contained',
      callback: async () => {
        employeePopup.remove();
        bodyScrollLock.enableBodyScroll(employeePopup);
      },
    });

    employeePopup.addEventListener('change', e => {
      console.log('employeeOptions', e.target, e.target.name, e.target.checked);

      if (e.target.name === 'location') {
        opts.includeTrainedOnly = e.target.checked ? 1 : 0;
      }
      if (e.target.name === 'hour') {
        opts.filterHours = e.target.checked ? 1 : 0;

        if (e.target.checked) {
          input.enableInputField(hoursInput);
        } else {
          input.disableInputField(hoursInput);
        }
      }
      if (e.target.name === 'hours') {
        opts.maxWeeklyHours = e.target.value;
      }
      if (e.target.name === 'minute') {
        opts.filterMinutes = e.target.checked ? 1 : 0;

        if (e.target.checked) {
          input.enableInputField(minutesInput);
        } else {
          input.disableInputField(minutesInput);
        }
      }
      if (e.target.name === 'minutes') {
        opts.minTimeBetweenShifts = e.target.value;
      }
      if (e.target.name === 'overlap') {
        opts.includeOverlaps = e.target.checked ? 1 : 0;
      }
      if (e.target.name === 'overlapShift') {
        // T.198690: exclude employees with an overlapping shift at a DIFFERENT location.
        opts.excludeDiffLocationOverlap = e.target.checked ? 1 : 0;
      }
      if (e.target.name === 'region') {
        opts.filterRegion = e.target.checked ? 1 : 0;

        if (e.target.checked) {
          input.enableInputField(regionDropdown);
        } else {
          input.disableInputField(regionDropdown);
        }
      }
      if (e.target.id === 'regionDropdown') {
        opts.region = e.target.options[e.target.selectedIndex].value;
      }
    });

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('btnWrap');
    buttonWrap.appendChild(savebtn);
    buttonWrap.appendChild(cancelbtn);

    employeePopup.appendChild(title);
    employeePopup.appendChild(optionsContainer);
    employeePopup.appendChild(buttonWrap);

    populateRegionDropdown(regionDropdown, opts.region);

    POPUP.show(employeePopup);
  }
  // - add individuals -
  async function getConsumersForIndivualPop(selectedDate, selectedLocationID) {
    try {
      const todaysDate =
        selectedDate == undefined ? dates.getTodaysDateObj() : new Date(selectedDate);
      todaysDate.setHours(0, 0, 0, 0);
      const filterDate = dates.formatISO(todaysDate, { representation: 'date' });

      const daysBackDate = dates.subDays(todaysDate, $.session.defaultProgressNoteReviewDays);
      const retrieveId =
        selectedLocationID === '%' || selectedLocationID === '' ? '0' : selectedLocationID;
      const data = await _UTIL.fetchData('getConsumersByGroupJSON', {
        groupCode: 'All',
        retrieveId: retrieveId,
        serviceDate: filterDate,
        daysBackDate: dates.formatISO(daysBackDate, { representation: 'date' }),
        isActive: 'No',
      });

      if (!data.getConsumersByGroupJSONResult) return [];

      const consumers = data.getConsumersByGroupJSONResult.reduce((acc, cv) => {
        acc[cv.id] = cv;
        return acc;
      }, {});

      const sortedConsumers = Object.values(consumers).sort((a, b) => {
        if (a.LN < b.LN) return -1;
        if (a.LN > b.LN) return 1;

        if (a.FN < b.FN) return -1;
        if (a.FN > b.FN) return 1;

        return 0;
      });

      return sortedConsumers;
    } catch (error) {
      console.log('uh oh something went horribly wrong :(', error.message);
      return [];
    }
  }
  async function showAddIndividualPopup(
    onSelectCallback,
    selectedConsumers,
    rosterDate,
    selectedLocationID,
  ) {
    let newSelectedConsumers = [...selectedConsumers];

    const addIndividualPopup = POPUP.build({
      id: 'addIndividualPopup',
      hideX: true,
    });

    const consumerWrap = document.createElement('div');
    consumerWrap.classList.add('rosterCardsWrap');

    const savebtn = button.build({
      text: 'Update',
      style: 'secondary',
      type: 'contained',
      callback: async () => {
        addIndividualPopup.remove();
        onSelectCallback(newSelectedConsumers);
      },
    });
    const cancelbtn = button.build({
      text: 'Cancel',
      style: 'secondary',
      type: 'outlined',
      callback: () => {
        addIndividualPopup.remove();
        onSelectCallback(null);
      },
    });

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('btnWrap');
    buttonWrap.appendChild(savebtn);
    buttonWrap.appendChild(cancelbtn);

    addIndividualPopup.appendChild(consumerWrap);
    addIndividualPopup.appendChild(buttonWrap);

    POPUP.show(addIndividualPopup);

    const spinner = PROGRESS.SPINNER.get('Gathering Individuals...');
    consumerWrap.appendChild(spinner);

    const consumersRes = await getConsumersForIndivualPop(rosterDate, selectedLocationID);
    consumersRes.forEach(c => {
      const consumerString = `${c.FN} ${c.LN}|${c.id}`;

      const gridAnimationWrapper = document.createElement('div');
      gridAnimationWrapper.classList.add('rosterCardWrap');

      const rosterCard = new RosterCard({
        consumerId: c.id,
        firstName: c.FN,
        middleName: c.MN,
        lastName: c.LN,
      });
      rosterCard.rootElement.id = consumerString;
      rosterCard.renderTo(gridAnimationWrapper);
      consumerWrap.appendChild(gridAnimationWrapper);

      if (newSelectedConsumers.some(consumer => consumer.id === c.id)) {
        gridAnimationWrapper.classList.add('selected');
      }

      gridAnimationWrapper.addEventListener('click', () => {
        const index = newSelectedConsumers.findIndex(consumer => consumer.consumerId === c.id);

        if (index === -1) {
          newSelectedConsumers.push({
            consumerName: `${c.FN} ${c.LN}`,
            consumerId: c.id,
            workCodeId: '',
            delete: false,
            og: false,
          });

          gridAnimationWrapper.classList.add('selected');
          return;
        }

        const isSelected = gridAnimationWrapper.classList.contains('selected');
        gridAnimationWrapper.classList.toggle('selected', !isSelected);

        if (newSelectedConsumers[index].og) {
          newSelectedConsumers[index].delete = isSelected ? true : false;
        } else {
          if (isSelected) newSelectedConsumers.splice(index, 1);
        }

        gridAnimationWrapper.classList.remove('selected');
      });
    });

    spinner.remove();
  }
  // - shift popup -
  class WeekViewDatePicker {
    constructor(opts) {
      this.onDateChange = opts.onDateChange;

      // Dates
      this.selectedDates = [...opts.selectedDates];
      this.weekStart = dates.startOfWeek(opts.defaultDate);
      this.weekEnd = dates.endOfWeek(opts.defaultDate);
      this.daysToRender = dates.eachDayOfInterval({
        start: this.weekStart,
        end: this.weekEnd,
      });

      // DOM
      this.rootEle = document.createElement('div');
      this.weekWrapEle = document.createElement('div');
      this.prevWeekNavBtn = document.createElement('div');
      this.nextWeekNavBtn = document.createElement('div');

      this.build();
      this.render();
    }

    handleClick(e) {
      if (e.target === this.prevWeekNavBtn) {
        this.weekStart = dates.subWeeks(this.weekStart, 1);
        this.weekEnd = dates.subWeeks(this.weekEnd, 1);
        this.daysToRender = dates.eachDayOfInterval({
          start: this.weekStart,
          end: this.weekEnd,
        });

        this.render();
        return;
      }
      if (e.target === this.nextWeekNavBtn) {
        this.weekStart = dates.addWeeks(this.weekStart, 1);
        this.weekEnd = dates.addWeeks(this.weekEnd, 1);
        this.daysToRender = dates.eachDayOfInterval({
          start: this.weekStart,
          end: this.weekEnd,
        });

        this.render();
        return;
      }
      if (e.target.dataset.target === 'date') {
        if (e.target.classList.contains('selected')) {
          this.selectedDates = this.selectedDates.filter(d => d !== e.target.dataset.date);
          e.target.classList.remove('selected');
        } else {
          this.selectedDates.push(e.target.dataset.date);
          e.target.classList.add('selected');
        }

        this.onDateChange([...this.selectedDates]);

        return;
      }
    }

    render() {
      const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      this.weekWrapEle.innerHTML = '';

      for (let index = 0; index < this.daysToRender.length; index++) {
        const dateWrapEle = document.createElement('div');
        dateWrapEle.classList.add('dateWrap');
        dateWrapEle.setAttribute('data-target', 'date');

        const month = this.daysToRender[index].getMonth() + 1;
        const day = this.daysToRender[index].getDate();
        const year = this.daysToRender[index].getFullYear();

        const dateString = this.daysToRender[index].toDateString();
        const dateStringISO = UTIL.getFormattedDateFromDate(new Date(dateString), {
          format: 'iso',
        });
        dateWrapEle.setAttribute('data-date', dateStringISO);
        if (this.selectedDates.includes(dateStringISO)) {
          dateWrapEle.classList.add('selected');
        }

        const nameEle = document.createElement('div');
        nameEle.textContent = `${dayNames[index]}`;

        const dateEle = document.createElement('div');
        dateEle.textContent = `${month}/${day}`;

        dateWrapEle.appendChild(nameEle);
        dateWrapEle.appendChild(dateEle);

        this.weekWrapEle.appendChild(dateWrapEle);
      }
    }

    build() {
      this.rootEle.classList.add('weekViewDatePicker');
      this.weekWrapEle.classList.add('weekWrap');
      this.prevWeekNavBtn.classList.add('prevWeekBtn');
      this.nextWeekNavBtn.classList.add('nextWeekBtn');

      this.prevWeekNavBtn.appendChild(Icon.getIcon('arrowLeft'));
      this.nextWeekNavBtn.appendChild(Icon.getIcon('arrowRight'));

      this.rootEle.appendChild(this.prevWeekNavBtn);
      this.rootEle.appendChild(this.weekWrapEle);
      this.rootEle.appendChild(this.nextWeekNavBtn);

      this.rootEle.addEventListener('click', this.handleClick.bind(this));
    }
  }
  async function showOverlapWarningPopup(isOverlapSameLocation) {
    return new Promise(resolve => {
      const overlapShiftPopup = POPUP.build({
        id: 'saveConflictingShiftsPopup',
        hideX: true,
      });

      const message = document.createElement('p');
      const messageText = isOverlapSameLocation
        ? 'This employee is already scheduled to work a shift at another location during this time.  Do you still want to save this shift?'
        : 'This employee is already scheduled on a shift that overlaps with this one.  Are you sure you want to save this shift?';
      message.textContent = messageText;
      message.classList.add('message');

      const closeAndResolve = value => {
        overlapShiftPopup.remove();
        resolve(value);
      };

      const yesBtn = button.build({
        text: 'Yes',
        style: 'secondary',
        type: 'contained',
        callback: () => closeAndResolve('Y'),
      });
      const noBtn = button.build({
        text: 'No',
        style: 'secondary',
        type: 'outlined',
        callback: () => closeAndResolve('N'),
      });

      // Build
      //------------------------------------------
      const buttonWrap = document.createElement('div');
      buttonWrap.classList.add('btnWrap');
      buttonWrap.append(yesBtn);
      buttonWrap.append(noBtn);

      overlapShiftPopup.append(message);
      overlapShiftPopup.append(buttonWrap);

      POPUP.show(overlapShiftPopup);
    });
  }
  async function handleSaveUpdateShift(data) {
    try {
      if ($.session.flag.overlapWarning) {
        data.saveOverlap = '';
      }

      let resp = (await _UTIL.fetchData('saveOrUpdateShift', { ...data })).saveOrUpdateShiftResult;
      let parsedRes = JSON.parse(resp);

      if (parsedRes[0] && parsedRes[0].Type === 'IC') {
        return 'consumer';
      }

      if (parsedRes[0] && parsedRes[0].Type === 'CS') {
        if (!$.session.flag.overlapWarning) {
          return 'conflict';
        }

        let isOverlapSameLocation = parsedRes.some(item => item.SameLocation === 'T');
        const saveOverlap = await showOverlapWarningPopup(isOverlapSameLocation);

        if (saveOverlap === 'N') {
          return 'cancel';
        }

        if ($.session.flag.overlapWarning) {
          data.saveOverlap = 'Y';
        }
        resp = (await _UTIL.fetchData('saveOrUpdateShift', { ...data })).saveOrUpdateShiftResult;
        parsedRes = JSON.parse(resp);
      }

      parsedRes = parsedRes.map(item => item.ShiftID);

      const selectedLocationId = SchedulingCalendar.getSelectedLocationId();
      const selectedEmployeeId = SchedulingCalendar.getSelectedEmployeeId();

      await SchedulingCalendar.fetchCalendarEvents(selectedLocationId, selectedEmployeeId);
      SchedulingCalendar.renderCalendarEvents();

      return 'success';
    } catch (error) {
      console.log(error);
      return false;
    }
  }
  //
  function populateShiftLocationDropdown(locationDropdown, defaultValue = '') {
    const locations = SchedulingCalendar.getLocations();

    const dropdownData = locations
      .map(d => ({
        value: d.locationId,
        text: d.locationName,
      }))
      .filter(l => !l.id);

    dropdownData.unshift({
      value: '',
      text: '',
    });

    dropdown.populate(locationDropdown, dropdownData, defaultValue);
  }
  function populateShiftEmployeeDropdown(
    employeeDropdown,
    defaultValue = 'null',
    checkRequiredFieldsShiftPopup,
  ) {
    let dropdownData = [];

    shiftEmployees.forEach(d =>
      dropdownData.push({
        value: d.Person_ID,
        text: d.EmployeeName,
      }),
    );

    dropdownData.sort(sortEmployeeString);

    dropdownData.unshift({
      value: 'null',
      text: '',
    });
    dropdownData.unshift({
      value: 'none',
      text: '(none)',
    });

    dropdown.populate(employeeDropdown, dropdownData, defaultValue);

    if (defaultValue === 'null') {
      employeeDropdown.classList.add('error');
      checkRequiredFieldsShiftPopup();
    }
  }
  function populateShiftColorDropdown(colorDropdown, defaultValue = '') {
    const dropdownData = [
      { value: '', text: '' }, // default gray
      { value: 'blue', text: 'Blue' },
      { value: 'green', text: 'Green' },
      { value: 'orange', text: 'Orange' },
      { value: 'purple', text: 'Purple' },
      { value: 'red', text: 'Red' },
      { value: 'yellow', text: 'Yellow' },
    ];

    dropdown.populate(colorDropdown, dropdownData, defaultValue);
  }
  function populateShiftTypeDropdown(shiftTypeDropdown, defaultValue = '') {
    const dropdownData = [
      { value: '', text: '' },
      { value: 'A', text: 'Awake' },
      { value: 'N', text: 'Night' },
      { value: 'S', text: 'Sleep' },
    ];

    dropdown.populate(shiftTypeDropdown, dropdownData, defaultValue);
  }
  function populateWorkCodeDropdown(workcodeDropdown, defaultValue = '', forIndividual = false) {
    const dropdownData = workcodes
      .filter(wc => {
        if (forIndividual) {
          return wc.active === 'Y' && wc.billable === 'Y' ? true : false;
        } else {
          return wc.active === 'Y' && wc.billable === 'N' ? true : false;
        }
      })
      .sort((a, b) => {
        return a.workcodename.localeCompare(b.workcodename);
      })
      .map(wc => {
        return {
          text: wc.workcodename,
          value: wc.workcodeid,
        };
      });

    dropdownData.unshift({
      value: '',
      text: '',
    });

    dropdown.populate(workcodeDropdown, dropdownData, defaultValue);
  }
  function showDeleteShiftWarningPopup(callback) {
    const warningPopup = POPUP.build({
      id: 'deleteShiftWarningPopup',
      hideX: true,
    });

    const warningMessage = document.createElement('p');
    warningMessage.innerHTML = 'Are you sure you want to delete this shift?';

    const yesBtn = button.build({
      text: 'Yes',
      style: 'danger',
      type: 'contained',
      callback: () => {
        DOM.ACTIONCENTER.removeChild(warningPopup);
        callback('Y');
      },
    });
    const noBtn = button.build({
      text: 'No',
      style: 'secondary',
      type: 'contained',
      callback: () => {
        DOM.ACTIONCENTER.removeChild(warningPopup);
        callback('N');
      },
    });

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('btnWrap');
    buttonWrap.appendChild(yesBtn);
    buttonWrap.appendChild(noBtn);

    warningPopup.appendChild(warningMessage);
    warningPopup.appendChild(buttonWrap);

    POPUP.show(warningPopup);
  }
  function formatConsumerNameResp(consumerNames) {
    if (!consumerNames) return [];

    return consumerNames.split(',').map(c => {
      let splitString = c.split('|');
      let workCodeId = splitString.pop();
      let consumerId = splitString.pop();

      splitString = c.split('|');
      workCodeId = splitString.pop();
      consumerId = splitString.pop();

      return {
        consumerName: splitString[0],
        consumerId: consumerId,
        workCodeId: workCodeId,
        delete: false,
        og: true,
      };
    });
  }
  async function showShiftPopup(data, eventTypeID, isCopy, selectedDate) {
    const isNew = data && !isCopy ? false : true;
    const readOnly = !isNew && !$.session.schedulingUpdate;
    let fieldChangeCheck = false;

    const shiftData = data
      ? {
          shiftId: data.shiftId,
          shiftType: data.shiftType,
          locationId: data.locationId,
          employeeId: data.personID === '' ? 'none' : data.personID,
          color: data.color,
          workCodeId: data.workCodeId,
          startTime: data.startTime,
          endTime: data.endTime,
          shiftNotes: data.shiftNotes,
          notifyEmployee: 'N', // Y or N
          publishShift: data.publishDate === '' ? 'F' : 'T', // T or F
          consumerNames: formatConsumerNameResp(data.consumerNames),
          date: [dates.formateToISO(data.serviceDate.split(' ')[0])],
        }
      : {
          shiftId: '',
          shiftType: '',
          locationId: '',
          employeeId: 'null',
          color: '',
          workCodeId: '',
          startTime: '',
          endTime: '',
          shiftNotes: '',
          notifyEmployee: 'N',
          publishShift: 'F',
          consumerNames: [],
          date: [],
        };

    if (isNew && selectedDate) shiftData.date.push(selectedDate);

    const shiftPopup = POPUP.build({
      id: 'shiftDetailPopup',
      hideX: !$.session.schedulingSecurity ? false : true,
    });

    if (!$.session.schedulingSecurity) {
      const shiftDate = data.serviceDate.split(' ')[0];
      let startTime = data.startTime;
      let endTime = data.endTime;
      startTime = dates.convertFromMilitary(startTime);
      endTime = dates.convertFromMilitary(endTime);
      const consumers = data.consumerNames
        ? data.consumerNames
            .split(',')
            .map(v => v.split('|')[0])
            .join(',')
        : '';
      const location = data.locationName;
      const shiftNotes = data.shiftNotes;
      const workCode = `${data.workCode} - ${data.workCodeDescription}`;
      let shiftType = data.shiftType;
      shiftType =
        shiftType === 'A'
          ? 'Awake'
          : shiftType === 'N'
          ? 'Night'
          : shiftType === 'D'
          ? 'Day'
          : shiftType === 'S'
          ? 'Sleep'
          : '';

      // popup details
      wrap = document.createElement('div');
      wrap.innerHTML = `
        <div class="detailsHeading">
          <h2>Shift Details</h2>
          <p class="smallDetail font-mediumEmphasis">${shiftDate}</p>
        </div>
        <div class="detailsBody">
          <div class="location popupDetailsLine">
            <h4 class="label">Location:  </h4>
            <p>${location}</p>
          </div>
          <hr>
          <div class="time popupDetailsLine">
            <h4 class="label">Time:  </h4>
            <p>${startTime} - ${endTime}</p>
          </div>
          <hr>
          <div class="employee popupDetailsLine">
            <h4 class="label">Consumers:  </h4>
            <p>${consumers}</p>
          </div>
          <hr>
          <div class="workCode popupDetailsLine">
            <h4 class="label">Work Code:  </h4>
            <p>${workCode}</p>
          </div>
          <hr>
          <div class="shiftType popupDetailsLine">
            <h4 class="label">Shift Type:  </h4>
            <p>${shiftType}</p>
          </div>
          <hr>
          <div class="shiftNotes popupDetailsLine">
            <h4 class="label">Notes:  </h4>
            <p>${shiftNotes}</p>
          </div>
        </div>
      `;
      shiftPopup.appendChild(wrap);
    } else {
      if (isCopy) {
        shiftData.shiftId = '';
        shiftData.employeeId = 'null';

        const copyHeading = document.createElement('h2');
        copyHeading.textContent = 'Copy Shift';
        shiftPopup.appendChild(copyHeading);
      }

      // Helpers
      const checkRequiredFieldsShiftPopup = () => {
        let errors = [...shiftPopup.querySelectorAll('.error')];

        if (errors.length > 0 || shiftData.date.length === 0) {
          savebtn.classList.add('disabled');
        } else {
          savebtn.classList.remove('disabled');
        }
      };
      const checkForChangedFields = () => {
        // check date
        const todaysDate = dates.getTodaysDateObj();
        const anyDatesAfterToday = shiftData.date.filter(date => {
          const isAfter = dates.isAfter(todaysDate, new Date(date));
          const isToday = dates.isEqual(todaysDate, new Date(date));
          return isAfter || isToday ? true : false;
        });

        const shiftTypeChange = shiftData.shiftType !== data.shiftType;
        const locationChange = shiftData.locationId !== data.locationId;
        const employeeChange = shiftData.employeeId !== data.personID;
        const startTimeChange = shiftData.startTime !== data.startTime;
        const endTimeChange = shiftData.endTime !== data.endTime;
        const originalPublishedStatus = data.publishDate === '' ? 'F' : 'T';
        const publishShiftChange = shiftData.publishShift !== originalPublishedStatus;

        const fieldChangesMade =
          shiftTypeChange ||
          locationChange ||
          employeeChange ||
          startTimeChange ||
          endTimeChange ||
          publishShiftChange;
        if (fieldChangesMade && anyDatesAfterToday) {
          // If the user makes any change to the values displayed on the form AND the date on the form is after today,
          // then the checkbox should automatically get checked and enabled.
          input.enableInputField(notifyEmployeeCheckbox);

          if (!fieldChangeCheck) {
            shiftData.notifyEmployee = 'Y';
            notifyEmployeeCheckbox.querySelector('input').checked = true;
          }

          fieldChangeCheck = true;
        } else {
          // If the user makes no change to the form OR the date on the form is null or before today,
          // then the box should be unchecked and disabled
          fieldChangeCheck = false;
          shiftData.notifyEmployee = 'N';
          input.disableInputField(notifyEmployeeCheckbox);
          notifyEmployeeCheckbox.querySelector('input').checked = false;
        }
      };

      // Shift Employees
      filterShiftEmployeesOpts = {
        locationId: shiftData.locationId,
        includeTrainedOnly: 1,
        includeOverlaps: 1,
        maxWeeklyHours: -1,
        minTimeBetweenShifts: -1,
        shiftdate: shiftData.date,
        shiftStartTime: shiftData.startTime ? shiftData.startTime : '00:00:00',
        shiftEndTime: shiftData.endTime ? shiftData.endTime : '00:00:00',
        region: '',
        // just for checkboxes
        filterHours: 0,
        filterMinutes: 0,
        filterRegion: 0,
      };
      // T.198690: 0 = off, 1 = exclude employees with an overlapping shift at a different location
      // T.198690: if $.session.flag.employeeFilter is false the value is and must always be -1, this flags it off in the c#, if falg is true we default to 1
      if ($.session.flag.employeeFilter) {
        filterShiftEmployeesOpts.excludeDiffLocationOverlap = 1;
      } else {
        filterShiftEmployeesOpts.excludeDiffLocationOverlap = -1;
      }

      const getRetrieveDataForGetEmployeeDropdown = retrieveData => {
        const data = { ...retrieveData };

        if (!data.locationId) {
          data.includeTrainedOnly = 0;
        }
        if (data.shiftdate.length === 0) {
          data.includeOverlaps = 0;
          if ($.session.flag.employeeFilter) {
            data.excludeDiffLocationOverlap = 0;
          } else {
            data.excludeDiffLocationOverlap = -1;
          }
          data.maxWeeklyHours = -1;
          data.minTimeBetweenShifts = -1;
          data.shiftdate = '';
        } else {
          data.shiftdate = data.shiftdate.join(',');
        }

        if (data.shiftStartTime === '00:00:00' || data.shiftEndTime === '00:00:00') {
          data.maxWeeklyHours = -1;
          data.minTimeBetweenShifts = -1;
        }

        if (data.region === '') {
          data.region = '%';
        }

        delete data.filterHours;
        delete data.filterMinutes;
        delete data.filterRegion;

        return data;
      };
      const updateShiftEmployees = async () => {
        const retrieveData = getRetrieveDataForGetEmployeeDropdown(filterShiftEmployeesOpts);
        if ($.session.flag[200249]) {
          // 200249
          retrieveData.shiftId = shiftData.shiftId ? parseInt(shiftData.shiftId) : 0;
        } else {
          retrieveData.shiftId = -1;
        }

        shiftEmployees = (
          await _UTIL.fetchData('getEmployeeDropdown', {
            ...retrieveData,
            isCopy: isCopy ? 'Y' : 'N',
          })
        ).getEmployeeDropdownResult;

        if (
          !shiftEmployees.find(empData => empData.Person_ID === shiftData.employeeId) &&
          shiftData.employeeId !== 'none'
        ) {
          if (isNew) {
            shiftData.employeeId = 'null';
            employeeDropdown.classList.add('error');
          } else {
            // 200249: getEmployeeDropdown excludes the shift being edited (via @shiftId), so if the
            // originally-assigned employee is no longer in the list it's a real conflict (e.g. an
            // overlapping shift at the same location created by a time change) and they must be cleared.
            if ($.session.flag[200249] || data.personID !== shiftData.employeeId) {
              shiftData.employeeId = 'null';
              employeeDropdown.classList.add('error');
            }
          }
        }

        populateShiftEmployeeDropdown(
          employeeDropdown,
          shiftData.employeeId,
          checkRequiredFieldsShiftPopup,
        );
      };

      const rd = getRetrieveDataForGetEmployeeDropdown(filterShiftEmployeesOpts);
      const retrieveData = {
        ...rd,
        isCopy: isCopy ? 'Y' : 'N',
      };

      if ($.session.flag[200249]) {
        // 200249
        retrieveData.shiftId = shiftData.shiftId ? parseInt(shiftData.shiftId) : 0;
      } else {
        retrieveData.shiftId = -1;
      }

      shiftEmployees = (await _UTIL.fetchData('getEmployeeDropdown', retrieveData))
        .getEmployeeDropdownResult;

      // Shift Inputs
      const defaultDate = ScheduleCalendar.getCurrentDate();
      const shiftDateSelect = new WeekViewDatePicker({
        defaultDate:
          shiftData.date.length === 0 ? defaultDate : new Date(`${shiftData.date[0]} 00:00:00`),
        selectedDates: [...shiftData.date],
        async onDateChange(newDateArray) {
          shiftData.date = [...newDateArray];
          filterShiftEmployeesOpts.shiftdate = shiftData.date;
          await updateShiftEmployees();

          checkRequiredFieldsShiftPopup(savebtn);
        },
      });
      const filterEmployeesBtn = button.build({
        text: 'Filter Employee List',
        style: 'secondary',
        type: 'contained',
        classNames: 'filterEmployeesBtn',
      });
      const locationDropdown = dropdown.build({
        dropdownId: 'shiftLocationDropdown',
        label: 'Location',
        style: 'secondary',
        required: true,
      });
      const employeeDropdown = dropdown.build({
        dropdownId: 'shiftEmployeeDropdown',
        label: 'Employee',
        style: 'secondary',
      });
      const shiftTypeDropdown = dropdown.build({
        dropdownId: 'shiftType',
        label: 'Shift Type',
        style: 'secondary',
      });
      const shiftNote = input.build({
        label: 'Shift Notes',
        type: 'textarea',
        value: shiftData.shiftNotes,
      });
      const startTimeInput = input.build({
        label: 'Start Time',
        type: 'time',
        style: 'secondary',
        value: shiftData.startTime,
      });
      startTimeInput.classList.add('startTimeInput');
      const endTimeInput = input.build({
        label: 'End Time',
        type: 'time',
        style: 'secondary',
        value: shiftData.endTime,
      });
      endTimeInput.classList.add('endTimeInput');

      // T.200249: refresh the employee dropdown only when the user finishes entering a time
      // (on focus-out), once both start and end are complete and valid - so a partially-typed
      // time (e.g. mid-typing "9:28") never fires the availability check and removes an
      // otherwise-eligible employee. (focusout bubbles from the inner input to this wrapper.)
      const refreshEmployeesOnTimeFocusOut = () => {
        if (shiftData.startTime && shiftData.endTime && shiftData.startTime < shiftData.endTime) {
          updateShiftEmployees();
        }
      };
      startTimeInput.addEventListener('focusout', refreshEmployeesOnTimeFocusOut);
      endTimeInput.addEventListener('focusout', refreshEmployeesOnTimeFocusOut);

      const timeErrorMessage = document.createElement('p');
      timeErrorMessage.textContent = 'Start time must be before end time';
      timeErrorMessage.style.color = 'red';
      timeErrorMessage.style.display = 'none';
      timeErrorMessage.style.flexBasis = '100%';
      timeErrorMessage.style.margin = '-10px 0 0';

      const updateTimeErrorMessage = () => {
        const invalidTimeOrder =
          shiftData.startTime && shiftData.endTime && shiftData.startTime >= shiftData.endTime;
        timeErrorMessage.style.display = invalidTimeOrder ? 'block' : 'none';
      };

      const colorDropdown = dropdown.build({
        dropdownId: 'colorDropdown',
        label: 'Color',
        style: 'secondary',
      });
      const workCodeDropdown = dropdown.build({
        dropdownId: 'workcodesingle',
        label: 'Work Code',
        style: 'secondary',
      });
      const notifyEmployeeCheckbox = input.buildCheckbox({
        text: 'Notify Employee',
        isChecked: false,
      });
      const publishShift = input.buildCheckbox({
        text: 'Publish Shift',
        isChecked: shiftData.publishShift === 'T' ? true : false,
      });

      // Individual Section
      const addIndividualBtn = button.build({
        text: '+ Add Individual',
        style: 'secondary',
        type: 'contained',
        classNames: 'addIndividualBtn',
      });
      const individualCardWrap = document.createElement('div');
      individualCardWrap.classList.add('individualCardWrap');
      if (shiftData.consumerNames.length > 0) {
        const consumerNames = shiftData.consumerNames;
        consumerNames.forEach(cn => {
          const [first, last] = cn.consumerName.split(' ');

          const innerWrap = document.createElement('div');
          innerWrap.classList.add('innerCardWrap');
          individualCardWrap.append(innerWrap);

          const rosterCard = new RosterCard({
            consumerId: cn.consumerId,
            firstName: first,
            middleName: '',
            lastName: last,
          });

          const workCodeIndividualDropdown = dropdown.build({
            dropdownId: `workcode${cn.consumerId}`,
            label: 'Work Code',
            style: 'secondary',
          });

          rosterCard.renderTo(innerWrap);

          if (
            $.session.schedulingSecurity &&
            $.session.singleEntryPermission == 'Anywhere_SingleEntry'
          ) {
            innerWrap.append(workCodeIndividualDropdown);
            populateWorkCodeDropdown(workCodeIndividualDropdown, cn.workCodeId, true);
          }
        });
      }

      // Action Buttons
      const savebtn = button.build({
        text: 'Save',
        style: 'secondary',
        type: 'contained',
        callback: async () => {
          if (savebtn.classList.contains('disabled')) return;

          let consumerIdString;

          consumerIdString = shiftData.consumerNames
            .map(n =>
              n.delete ? `${n.consumerId}DEL|${n.workCodeId}` : `${n.consumerId}|${n.workCodeId}`,
            )
            .join(',');

          const success = await handleSaveUpdateShift(
            {
              shiftId: shiftData.shiftId,
              shiftType: shiftData.shiftType,
              dateString: shiftData.date.join(','),
              consumerIdString: consumerIdString,
              startTime: shiftData.startTime,
              endTime: shiftData.endTime,
              color: shiftData.color,
              shiftNotes: shiftData.shiftNotes,
              locationId: shiftData.locationId,
              notifyEmployee: shiftData.notifyEmployee,
              publishShift: shiftData.publishShift,
              personId: shiftData.employeeId,
              saveUpdateFlag: isNew ? 'S' : 'U',
              workCodeIdSingle: shiftData.workCodeId,
            },
            shiftPopup,
            isShiftGroupPopupOpen,
          );

          if (success === 'cancel') {
            return;
          }

          POPUP.hide(shiftPopup);
          if (isShiftGroupPopupOpen) {
            overlay.show();
          }

          if (success === false) {
            showSuccessFailPopup(false, 'Error Saving', !isShiftGroupPopupOpen);
            return;
          }

          if (success === 'consumer') {
            showSuccessFailPopup(false, 'Unable To Save, Invalid Consumer', !isShiftGroupPopupOpen);
            return;
          }

          if (success === 'conflict') {
            showSuccessFailPopup(
              false,
              'Unable To Save, Conflicting Shifts',
              !isShiftGroupPopupOpen,
            );
            return;
          }

          if (success === 'success') {
            showSuccessFailPopup(true, '', !isShiftGroupPopupOpen);

            if (isShiftGroupPopupOpen) {
              updateShiftGroupPopup();
            }
          }
        },
      });
      const cancelbtn = button.build({
        text: 'Cancel',
        style: 'secondary',
        type: 'outlined',
        callback: () => {
          POPUP.hide(shiftPopup);
          if (isShiftGroupPopupOpen) {
            overlay.show();
          }
        },
      });
      const deleteBtn = button.build({
        text: 'Delete',
        style: 'danger',
        type: 'contained',
        callback: async () => {
          shiftPopup.style.zIndex = '2';

          showDeleteShiftWarningPopup(async deleteShift => {
            if (deleteShift === 'N') {
              shiftPopup.style.zIndex = '101';
              return;
            }

            // const success = await schedulingAjax.deleteShift(shiftData.shiftId);
            const success = (
              await _UTIL.fetchData('deleteScheduleShift', { shiftId: shiftData.shiftId })
            ).deleteScheduleShiftResult;

            if (success) {
              POPUP.hide(shiftPopup);

              showSuccessFailPopup(true, 'Shift successfully deleted');

              const selectedLocationId = SchedulingCalendar.getSelectedLocationId();
              const selectedEmployeeId = SchedulingCalendar.getSelectedEmployeeId();

              await SchedulingCalendar.fetchCalendarEvents(selectedLocationId, selectedEmployeeId);
              SchedulingCalendar.renderCalendarEvents();

              if (isShiftGroupPopupOpen) {
                overlay.show();
                updateShiftGroupPopup();
              }
            } else {
              showSuccessFailPopup(false, 'Could not delete shift at this time.', false);
              shiftPopup.style.zIndex = '101';
            }
          });
        },
      });

      // Required Fields
      if (
        !shiftData.employeeId ||
        shiftData.employeeId === 'null' ||
        shiftData.employeeId === 'none'
      ) {
        colorDropdown.classList.add('disabled');
        shiftData.color = '';
      }
      if (!shiftData.locationId) {
        locationDropdown.classList.add('error');
        employeeDropdown.classList.add('disabled');
      }
      if (!shiftData.shiftType) {
        shiftTypeDropdown.classList.add('error');
      }
      if (!shiftData.startTime) startTimeInput.classList.add('error');
      if (!shiftData.endTime) endTimeInput.classList.add('error');
      updateTimeErrorMessage();

      // Disabled Fields
      if (!isNew) {
        input.disableInputField(notifyEmployeeCheckbox);
      }
      if (shiftData.workCodeId) {
        addIndividualBtn.classList.add('disabled');
      }

      // Event Listener
      shiftPopup.addEventListener('change', e => {
        if (e.target.id.includes('workcode')) {
          const selectedOption = e.target.options[e.target.selectedIndex];

          if (e.target.id === 'workcodesingle') {
            if (!workCodeDropdown.classList.contains('disabled')) {
              shiftData.workCodeId = selectedOption.value;
              if (shiftData.workCodeId) {
                addIndividualBtn.classList.add('disabled');
              } else {
                addIndividualBtn.classList.remove('disabled');
              }
            }
          } else {
            const targetId = e.target.id.replace('workcode', '');
            const consumer = shiftData.consumerNames.find(c => c.consumerId === targetId);

            if (consumer) {
              consumer.workCodeId = selectedOption.value;
            }
          }
        }
        if (e.target.parentElement === shiftTypeDropdown) {
          const selectedOption = e.target.options[e.target.selectedIndex];
          shiftData.shiftType = selectedOption.value;

          if (shiftData.shiftType === '') {
            shiftTypeDropdown.classList.add('error');
          } else {
            shiftTypeDropdown.classList.remove('error');
          }
        }
        if (e.target.parentElement === locationDropdown) {
          const selectedOption = e.target.options[e.target.selectedIndex];
          shiftData.locationId = selectedOption.value;
          filterShiftEmployeesOpts.locationId = shiftData.locationId;

          if (shiftData.locationId === '') {
            locationDropdown.classList.add('error');
            employeeDropdown.classList.add('disabled');
          } else {
            locationDropdown.classList.remove('error');
            employeeDropdown.classList.remove('disabled');
          }

          // Clear employee & update dropdown
          shiftData.employeeId = '';
          employeeDropdown.classList.add('error');
          updateShiftEmployees();

          // Clear out consumers/individuals
          shiftData.consumerNames = [];
          individualCardWrap.innerHTML = '';
          workCodeDropdown.style.display = 'flex';

          if (
            !shiftData.employeeId ||
            shiftData.employeeId === 'null' ||
            shiftData.employeeId === 'none'
          ) {
            shiftData.color = '';
            colorDropdown.classList.add('disabled');
            populateShiftColorDropdown(colorDropdown, shiftData.color);
          } else {
            colorDropdown.classList.remove('disabled');
          }
        }
        if (e.target.parentElement === employeeDropdown) {
          const selectedOption = e.target.options[e.target.selectedIndex];
          shiftData.employeeId = selectedOption.value;

          if (shiftData.employeeId === 'null') {
            employeeDropdown.classList.add('error');
          } else {
            employeeDropdown.classList.remove('error');
          }

          if (
            !shiftData.employeeId ||
            shiftData.employeeId === 'null' ||
            shiftData.employeeId === 'none'
          ) {
            shiftData.color = '';
            colorDropdown.classList.add('disabled');
            populateShiftColorDropdown(colorDropdown, shiftData.color);
          } else {
            colorDropdown.classList.remove('disabled');
          }
        }
        if (e.target.parentElement === colorDropdown) {
          if (!colorDropdown.classList.contains('disabled')) {
            const selectedOption = e.target.options[e.target.selectedIndex];
            shiftData.color = selectedOption.value;

            if (selectedOption?.value === '%') shiftData.color = 'white';
          }
        }
        if (e.target.parentElement === shiftNote) {
          shiftData.shiftNotes = e.target.value;
        }
        if (e.target.parentElement === startTimeInput) {
          shiftData.startTime = `${e.target.value}:00`;
          filterShiftEmployeesOpts.shiftStartTime = shiftData.startTime;

          if (
            !shiftData.startTime ||
            (shiftData.endTime && shiftData.startTime >= shiftData.endTime)
          ) {
            startTimeInput.classList.add('error');
          } else {
            startTimeInput.classList.remove('error');

            if (shiftData.endTime) {
              endTimeInput.classList.remove('error');
            }
            // T.200249: employee-dropdown refresh moved to the time inputs' focusout handler.
          }
          updateTimeErrorMessage();
        }
        if (e.target.parentElement === endTimeInput) {
          shiftData.endTime = `${e.target.value}:00`;
          filterShiftEmployeesOpts.shiftEndTime = shiftData.endTime;

          if (
            !shiftData.endTime ||
            (shiftData.startTime && shiftData.startTime >= shiftData.endTime)
          ) {
            endTimeInput.classList.add('error');
          } else {
            endTimeInput.classList.remove('error');

            if (shiftData.startTime) {
              startTimeInput.classList.remove('error');
            }
            // T.200249: employee-dropdown refresh moved to the time inputs' focusout handler.
          }
          updateTimeErrorMessage();
        }
        if (e.target.parentElement === notifyEmployeeCheckbox) {
          shiftData.notifyEmployee = e.target.checked ? 'Y' : 'N';
        }
        if (e.target.parentElement === publishShift) {
          shiftData.publishShift = e.target.checked ? 'T' : 'F';
        }

        checkRequiredFieldsShiftPopup(savebtn);
        if (!isNew) checkForChangedFields();
      });
      shiftPopup.addEventListener('click', async e => {
        if (e.target === filterEmployeesBtn) {
          showFilterEmployeePopup(updateShiftEmployees);
        }
        if (e.target === addIndividualBtn) {
          if (addIndividualBtn.classList.contains('disabled')) return;

          const datesSelectedCount = shiftData.date.length > 0 ? shiftData.date[0] : null;
          shiftPopup.style.opacity = 0.5;
          shiftPopup.style.pointerEvents = 'none';

          showAddIndividualPopup(
            consumers => {
              if (consumers) {
                shiftData.consumerNames = [...consumers];
                individualCardWrap.innerHTML = '';

                if (shiftData.consumerNames.length > 0) {
                  dropdown.setValue(workCodeDropdown, '');
                  shiftData.workCodeId = '';
                  workCodeDropdown.style.display = 'none';

                  const consumerNames = shiftData.consumerNames;
                  consumerNames.forEach(cn => {
                    const [fName, lName] = cn.consumerName.split(' ');

                    const innerWrap = document.createElement('div');
                    innerWrap.classList.add('innerCardWrap');
                    individualCardWrap.appendChild(innerWrap);

                    const rosterCard = new RosterCard({
                      consumerId: cn.consumerId,
                      firstName: fName,
                      middleName: '',
                      lastName: lName,
                    });

                    const workCodeIndividualDropdown = dropdown.build({
                      dropdownId: `workcode${cn.consumerId}`,
                      label: 'Work Code',
                      style: 'secondary',
                    });

                    rosterCard.renderTo(innerWrap);

                    if (
                      $.session.schedulingSecurity &&
                      $.session.singleEntryPermission == 'Anywhere_SingleEntry'
                    ) {
                      innerWrap.append(workCodeIndividualDropdown);
                      populateWorkCodeDropdown(workCodeIndividualDropdown, cn.workCodeId, true);
                    }
                  });
                } else {
                  workCodeDropdown.style.display = 'flex';
                }
              } else {
                workCodeDropdown.style.display = 'flex';
              }

              shiftPopup.style.opacity = 1;
              shiftPopup.style.pointerEvents = 'all';
            },
            shiftData.consumerNames,
            datesSelectedCount,
            shiftData.locationId,
          );
        }
      });
      individualCardWrap.addEventListener('click', e => {
        if (!$.session.schedulingSecurity || e.target.dataset.target !== 'rosterCard') return;

        const index = shiftData.consumerNames.findIndex(
          consumer => consumer.consumerId === e.target.dataset.id,
        );
        if (shiftData.consumerNames[index].og) {
          shiftData.consumerNames[index].delete = true;
        } else {
          shiftData.consumerNames.splice(index, 1);
        }

        e.target.parentElement.remove();

        if (
          shiftData.consumerNames.length === 0 ||
          shiftData.consumerNames.every(c => c.delete === true)
        ) {
          workCodeDropdown.style.display = 'flex';
        }
      });

      // Build Popup
      const mainInputsWrap = document.createElement('div');
      mainInputsWrap.classList.add('inputsWrap');
      mainInputsWrap.appendChild(startTimeInput);
      mainInputsWrap.appendChild(endTimeInput);
      mainInputsWrap.appendChild(timeErrorMessage);
      mainInputsWrap.appendChild(shiftTypeDropdown);
      mainInputsWrap.appendChild(locationDropdown);
      mainInputsWrap.appendChild(employeeDropdown);
      mainInputsWrap.appendChild(colorDropdown);
      mainInputsWrap.appendChild(workCodeDropdown);
      mainInputsWrap.appendChild(shiftNote);

      const buttonWrap = document.createElement('div');
      buttonWrap.classList.add('btnWrap');
      buttonWrap.appendChild(savebtn);
      buttonWrap.appendChild(cancelbtn);
      if (!isNew) {
        buttonWrap.appendChild(deleteBtn);
      }

      shiftPopup.appendChild(filterEmployeesBtn);
      shiftPopup.appendChild(shiftDateSelect.rootEle);
      shiftPopup.appendChild(mainInputsWrap);
      shiftPopup.appendChild(individualCardWrap);
      shiftPopup.appendChild(addIndividualBtn);
      shiftPopup.appendChild(publishShift);
      shiftPopup.appendChild(notifyEmployeeCheckbox);
      shiftPopup.appendChild(buttonWrap);

      if (!$.session.schedulingSecurity) {
        shiftPopup.remove(filterEmployeesBtn);
        shiftPopup.remove(colorDropdown);
        shiftPopup.remove(addIndividualBtn);
        shiftPopup.remove(notifyEmployeeCheckbox);
      }

      if (
        !$.session.schedulingSecurity ||
        $.session.singleEntryPermission !== 'Anywhere_SingleEntry'
      ) {
        workCodeDropdown.remove();
      } else if (shiftData.consumerNames && shiftData.consumerNames.length > 0) {
        workCodeDropdown.style.display = 'none';
      }

      // Populate Dropdowns
      populateShiftTypeDropdown(shiftTypeDropdown, shiftData.shiftType);
      populateShiftLocationDropdown(locationDropdown, shiftData.locationId);
      populateShiftEmployeeDropdown(
        employeeDropdown,
        shiftData.employeeId,
        checkRequiredFieldsShiftPopup,
      );
      populateShiftColorDropdown(colorDropdown, shiftData.color);
      if (
        $.session.schedulingSecurity &&
        $.session.singleEntryPermission == 'Anywhere_SingleEntry'
      ) {
        populateWorkCodeDropdown(workCodeDropdown, shiftData.workCodeId);
      }

      checkRequiredFieldsShiftPopup(savebtn);
    }

    const callOffBtn = button.build({
      text: 'Call Off',
      style: 'secondary',
      type: 'outlined',
      callback: () => {
        POPUP.hide(shiftPopup);
        renderRequestOffPopup(
          {
            shiftId: shiftData.shiftId,
            shiftDate: shiftData.date[0],
            shiftLocation: shiftData.locationId,
          },
          () => {
            const updatedShift = SchedulingCalendar.getCalendarEventData().find(
              event => event.eventId === shiftData.shiftId,
            );
            updatedShift.typeName = EVENT_TYPES[5];
            updatedShift.typeId = 5;

            const schedules = SchedulingCalendar.getSchedules();
            const updatedShiftScheduleCache = schedules.find(
              event => event.shiftId === shiftData.shiftId,
            );
            updatedShiftScheduleCache.typeName = EVENT_TYPES[5];
            updatedShiftScheduleCache.typeId = 5;

            ScheduleCalendar.updateEvent({ ...updatedShift });
          },
        );
      },
    });
    const requestShiftBtn = button.build({
      text: 'Request Shift',
      style: 'secondary',
      type: 'outlined',
      callback: async () => {
        POPUP.hide(shiftPopup);

        const { getOverlapStatusforSelectedShiftResult: overlapWithExistingShift } =
          // await schedulingAjax.getOverlapStatusforSelectedShiftAjax(shiftData.shiftId, $.session.PeopleId);
          await _UTIL.fetchData('getOverlapStatusforSelectedShift', {
            shiftId: shiftData.shiftId,
            personId: $.session.PeopleId,
          });

        if (overlapWithExistingShift == 'NoOverLap') {
          renderSendShiftRequestPopup(
            {
              token: $.session.Token,
              shiftId: shiftData.shiftId,
              personId: $.session.PeopleId,
              status: 'P',
              notifiedEmployeeId: null,
              shiftDate: shiftData.date[0],
              shiftLocation: shiftData.locationId,
            },
            () => {
              const updatedShift = SchedulingCalendar.getCalendarEventData().find(
                event => event.eventId === shiftData.shiftId,
              );
              updatedShift.typeName = EVENT_TYPES[4];
              updatedShift.typeId = 4;

              const schedules = SchedulingCalendar.getSchedules();
              const updatedShiftScheduleCache = schedules.find(
                event => event.shiftId === shiftData.shiftId,
              );
              updatedShiftScheduleCache.typeName = EVENT_TYPES[4];
              updatedShiftScheduleCache.typeId = 4;

              ScheduleCalendar.updateEvent({ ...updatedShift });
            },
          );
        } else {
          displayOverlapPopup(overlapWithExistingShift);
          return;
        }
      },
    });
    const cancelShiftBtn = button.build({
      text: 'Cancel Request',
      style: 'secondary',
      type: 'outlined',
      callback: () => {
        POPUP.hide(shiftPopup);

        // schedulingAjax.cancelRequestOpenShiftSchedulingAjax(shiftData.shiftId);
        _UTIL.fetchData('cancelRequestOpenShiftScheduling', {
          requestShiftId: shiftData.shiftId,
        });

        const updatedShift = SchedulingCalendar.getCalendarEventData().find(
          event => event.eventId === shiftData.shiftId,
        );
        updatedShift.typeName = EVENT_TYPES[3];
        updatedShift.typeId = 3;

        const schedules = SchedulingCalendar.getSchedules();
        const updatedShiftScheduleCache = schedules.find(
          event => event.shiftId === shiftData.shiftId,
        );
        updatedShiftScheduleCache.typeName = EVENT_TYPES[3];
        updatedShiftScheduleCache.typeId = 3;

        ScheduleCalendar.updateEvent({ ...updatedShift });
      },
    });

    // CALL OFF SHIFT
    if (
      !isNew &&
      eventTypeID === '1' && // eventType = 'My Shift'
      shiftData.employeeId === $.session.PeopleId &&
      $.session.schedAllowCallOffRequests === 'Y' &&
      $.session.schedulingUpdate
    ) {
      shiftPopup.appendChild(callOffBtn);
    }

    // REQUEST SHIFT
    if (
      !isNew &&
      eventTypeID === '3' && // open shifts only
      $.session.schedRequestOpenShifts === 'Y' &&
      !$.session.isPSI &&
      $.session.schedulingUpdate &&
      $.session.schedulingView
    ) {
      shiftPopup.appendChild(requestShiftBtn);
    }

    // CANCEL PENDING SHIFT REQUEST
    if (!isNew && eventTypeID === '4' && data && data.requestedById === $.session.PeopleId) {
      // Pending Request Open Shifts Only (eventTypeID = 4)
      shiftPopup.appendChild(cancelShiftBtn);
    }

    POPUP.show(shiftPopup);
  }

  // Appointments
  //-----------------------------------------------------------------------
  function showAppointmentPopup(data) {
    const date = data.dateScheduled.split(' ')[0];
    const time =
      data.timeScheduled !== ''
        ? dates.convertFromMilitary(data.timeScheduled)
        : dates.convertFromMilitary(data.dateScheduled.split(' ')[1]);
    const notes = data.notes;
    const consumer = data.consumerName;
    const provider = data.provider;
    const type = data.typeDescription;
    const reason = data.reason;

    const popup = POPUP.build({
      classNames: 'appointmentDetails',
      attributes: [{ key: 'appointmentId', value: data.medTrackingId }],
    });

    wrap = document.createElement('div');
    wrap.innerHTML = `
          <div class="detailsHeading">
            <h2>Appointment Details</h2>
            <p class="smallDetail font-mediumEmphasis">${date}</p>
          </div>
          
          <div class="detailsBody">
            ${
              data.timeScheduled
                ? `
              <div class="time popupDetailsLine">
                <h4 class="label">Time:</h4>
                <p>${time}</p>
              </div>
              <hr>
              `
                : ``
            }
            <div class="employee popupDetailsLine">
              <h4 class="label">Consumer:</h4>
              <p>${consumer}</p>
            </div>
            <hr>
            <div class="popupDetailsLine">
              <h4 class="label">Provider:</h4>
              <p>${provider}</p>
            </div>
            <hr>
            <div class="type popupDetailsLine">
              <h4 class="label">Type:</h4>
              <p>${type}</p>
            </div>
            <hr>
            <div class="reason popupDetailsLine">
              <h4 class="label">Reason:</h4>
              <p>${reason}</p>
            </div>
            <hr>
            <div class="shiftNotes popupDetailsLine">
              <h4 class="label">Notes:</h4>
              <p>${notes}</p>
            </div>
          </div>
      `;
    popup.appendChild(wrap);

    POPUP.show(popup);
  }

  // Main
  //-----------------------------------------------------------------------
  function showEventDetailsPopup({ eventTypeId, data, isCopy, selectedDate }) {
    if (eventTypeId === '6') {
      showAppointmentPopup(data);
      return;
    }

    showShiftPopup(data, eventTypeId, isCopy, selectedDate);
  }
  function reset() {
    shiftEmployees = [];
    filterShiftEmployeesOpts = undefined;
    regions = [];
    isShiftGroupPopupOpen = undefined;
    groupPopupEventLookup = undefined;
    groupPopupDateISO = undefined;
  }
  async function init(opts) {
    ScheduleCalendar = opts.ScheduleCalendar;

    if ($.session.schedulingSecurity) {
      const [regionsResp, workcodesResp] = await Promise.all([
        _UTIL.fetchData('getSchedulingRegions'),
        _UTIL.fetchData('getWorkCodesJSON', { getAllWorkCodes: 'Y' }),
      ]);

      regions = regionsResp.getSchedulingRegionsResult;
      workcodes = workcodesResp.getWorkCodesJSONResult;
    }
  }

  return {
    init,
    reset,
    showPopup: showEventDetailsPopup,
    showGroupPopup: showShiftGroupPopup,
  };
})();
